// vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
import React, { Fragment, lazy, Suspense, useMemo } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { encodeAdf } from '@atlassian/conversation-assistant-content-renderer';
import { StatusCitation } from '../ai-answer-body/ai-answer-result/rendered/status-citation';
var containerStyles = xcss({
  minHeight: '106px',
  paddingTop: 'space.100',
  paddingRight: 'space.300',
  paddingBottom: 'space.100',
  paddingLeft: 'space.300'
});
var containerStylesWithoutStreamingExpand = xcss({
  maxHeight: '160px',
  overflow: 'hidden'
});
var ReactRenderer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.renderer" */'@atlaskit/renderer').then(function (_ref) {
    var ReactRenderer = _ref.ReactRenderer;
    return {
      default: ReactRenderer
    };
  });
});
var MarkdownRenderer = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "react-markdown" */'react-markdown').then(function (_ref2) {
    var ReactMarkdown = _ref2.default;
    return {
      default: ReactMarkdown
    };
  });
});
export var AIAnswerLoadingStream = function AIAnswerLoadingStream(_ref3) {
  var markdown = _ref3.markdown;
  var docContent = useMemo(function () {
    return encodeAdf(markdown, false);
  }, [markdown]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [containerStyles, !fg('kd_sain_enable_expand_when_streaming') && containerStylesWithoutStreamingExpand]
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, fg('kd_smart_answers_use_adf_encoder') || fg('kd_smart_answers_use_adf_encoder_jira') ? /*#__PURE__*/React.createElement(ReactRenderer, {
    document: docContent,
    nodeComponents: {
      status: function status(props) {
        return /*#__PURE__*/React.createElement(StatusCitation, props);
      },
      // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
      // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
      media: function media() {
        return /*#__PURE__*/React.createElement(Fragment, null);
      },
      mediaSingle: function mediaSingle() {
        return /*#__PURE__*/React.createElement(Fragment, null);
      }
    }
  }) :
  /*#__PURE__*/
  // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
  // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
  React.createElement(MarkdownRenderer, {
    disallowedElements: ['img']
  }, markdown)));
};